import { TelegramImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={TelegramImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
